import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import {Router, Link as RouterLink,useLocation, useNavigate} from 'react-router-dom';
function handleClick(event) {
  // event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function BasicBreadcrumbs({name}) {
    const location = useLocation();

    const path = location.pathname;
    const userCampaignsRegex = /^\/user\/[^/]+\/campaigns$/;
    
    const campaginRegex = /^\/?campaign\/[^/]+\/details$/;
    const navigate = useNavigate();

    console.log("17",campaginRegex.test(path),location.pathname.replace("details",""));
    if (userCampaignsRegex.test(path)) {
      return (
        <div role="presentation" onClick={handleClick}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" to="/admin-dashboard"  component={RouterLink}>
              Dashboard
            </Link>
            <Link
              underline="hover"
              // color="inherit"
              sx={{ color: 'text.primary' }}
              to={location.pathname}
              component={RouterLink}
            >
              Campaigns
            </Link>
            {/* <Typography sx={{ color: 'text.primary' }}>Breadcrumbs</Typography> */}
          </Breadcrumbs>
        </div>
      );
    }else if(campaginRegex.test(path)){
      return (
        <div role="presentation" onClick={handleClick}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" to="/admin-dashboard"  component={RouterLink}>
              Dashboard
            </Link>
            <Link
              underline="hover" color="inherit" 
              // component={RouterLink}
              component="button"
      onClick={() => navigate(-1)} // 👈 goes back
            >
              Campaigns
            </Link>
            <Link
              underline="hover"
              // color="inherit"
              sx={{ color: 'text.primary' }}
              to={location.pathname}
              component={RouterLink}
            >
              {name}
            </Link>
            {/* <Typography sx={{ color: 'text.primary' }}>Breadcrumbs</Typography> */}
          </Breadcrumbs>
        </div>
      )
    }
  return null
  
}
